const projects = [
  {
    name: 'Data Management Experience',
    nameAlias: 'Workflow Redesign',
    description: 'Redesigned how data is added to Data.CMS.gov',
    descriptionAlias: 'Passcode required to view',
    url: 'data-management-experience',
    year: 2024,
    tag: 'Case Study',
    company: 'ICF',
    status: 'published',
    cover: 'default',
    featured: true,
    locked: true,
  },

  {
    name: 'Download Experience Redesign',
    nameAlias: 'Feature Redesign',
    description: 'Optimized data access on Data.CMS.gov',
    descriptionAlias: 'Passcode required to view',
    url: 'download-experience-redesign',
    year: 2023,
    tag: 'Case Study',
    company: 'ICF',
    status: 'published',
    cover: 'default',
    featured: true,
    locked: true,
  },
  {
    name: 'Open Data Platform Redesign',
    nameAlias: 'Site Redesign',
    description: "Modernizing CMS's open data platform",
    descriptionAlias: 'Passcode required to view',
    url: 'open-data-platform-redesign',
    year: 2022,
    tag: 'Project',
    company: 'ICF',
    status: 'published',
    cover: 'default',
    featured: false,
    overflow: true,
    locked: true,
  },
  {
    name: 'Visual QA',
    nameAlias: 'Design Integrity Framework',
    description: 'A process for ensuring design integrity',
    descriptionAlias: 'Passcode required to view',
    url: 'visual-qa',
    year: 2024,
    tag: 'Methodology',
    company: 'ICF',
    status: 'published',
    cover: 'default',
    featured: false,
    locked: true,
  },
  {
    name: 'Scalable Vector Icon System',
    description: 'Design system iconography',
    url: 'scalable-vector-icon-system',
    year: 2023,
    tag: 'Project',
    company: 'Side Project',
    status: 'published',
    cover: 'dynamic',
    featured: false,
    overflow: true,
    locked: false,
  },
]

// eslint-disable-next-line no-unused-vars
const archive = [
  {
    name: 'Gridpad',
    description: 'Insert description...',
    url: 'gridpad',
    year: 2022,
    tag: 'Untitled',
    company: 'Personal project',
    status: 'draft',
    cover: 'default',
    locked: false,
  },
  {
    name: 'Firefox Pinned Icons',
    description: 'Insert description...',
    url: 'firefox-pinned-icons',
    year: 2022,
    tag: 'Untitled',
    company: 'Personal project',
    status: 'draft',
    cover: 'default',
    locked: false,
  },
  {
    name: 'Pulse Analytics Dashboard',
    description: 'Compliance traning analytics web application',
    url: 'pulse-analytics-dashboard',
    year: 2017,
    tag: 'Untitled',
    company: 'New York Stock Exchange',
    status: 'draft',
    cover: 'default',
    locked: true,
  },
]

export default projects
